import React, { useEffect, useState } from "react";

import { MenuItem } from "@mui/material";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Select } from "../../../../../../../../../components/Form";
import SkeletonComponent from "../../../../../../../../../components/Generic/Skeleton";
import { Company } from "../../../../../../../../../models/company";
import { OptionsSwitch } from "../../../../../../../../../util/enums";
import Wrapper from "../Wrapper";
import useActions from "./hooks/useActions";

const ShipmentTrackingPreference = () => {
  const { t: translate } = useTranslation();

  const [allowAssociateAgent, setAllowAssociateAgent] = useState<boolean>(false);

  const { mutate, company, isLoading, isUpdating } = useActions();

  useEffect(() => {
    setAllowAssociateAgent(company?.allowAssociateAgent || false);
  }, [company]);

  const onSave = () => {
    if (company?.id) mutate({ id: company?.id, company: { allowAssociateAgent } as Company });
  };

  return (
    <Wrapper
      loading={isUpdating}
      actionButtonProps={{
        cancelDisabled: isLoading,
        onCancel: () => {
          setAllowAssociateAgent(company?.allowAssociateAgent || false);
        },
        saveDisabled: isLoading,
        onSave,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={8}>
          <Typography
            fontFamily="Manrope"
            fontWeight={700}
            fontSize="18px"
            lineHeight="27px"
            color="#465869"
          >
            {translate("agent")}
          </Typography>
          <Typography
            fontFamily="Manrope"
            fontWeight={500}
            fontSize="14px"
            lineHeight="21px"
            color="#475467"
          >
            {translate("hereYouCanChooseWheterToSeeTheNetworkAndHaveTheOptionToSelectAndAgent")}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={5}>
          <SkeletonComponent isLoading={isLoading}>
            <Select
              label={translate("networkVisible")}
              dataCy="networkVisible"
              name="networkVisible"
              value={allowAssociateAgent ? OptionsSwitch.YES : OptionsSwitch.NO}
              onChange={(event) => setAllowAssociateAgent(event.target.value === OptionsSwitch.YES)}
              displayEmpty
              placeholder={translate("selectAnOption")}
            >
              <MenuItem data-cy="yes" value={OptionsSwitch.YES}>
                {translate("yes")}
              </MenuItem>
              <MenuItem data-cy="no" value={OptionsSwitch.NO}>
                {translate("no")}
              </MenuItem>
            </Select>
          </SkeletonComponent>
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default ShipmentTrackingPreference;
